import React from 'react';
import { FILTER_TYPES, APP_EVENTS, TIME_WINDOW_UNITS, COUNT_OPS, PROPERTY_OPS } from '../../data/events';
import { segmentService } from '../../services/segmentService';
import { tableForEvent } from '../../utils/segmentConditions';
import styles from './FilterRow.module.css';

let _propId = 0;

function TimeWindowInput({ value, unit, onChange }) {
  return (
    <div className={styles.countGroup}>
      <input
        className={styles.countInp}
        type="number"
        min="1"
        value={value || ''}
        onChange={(e) => onChange({ timeWindowValue: e.target.value })}
      />
      <select
        className={styles.selSm}
        value={unit || 'days'}
        onChange={(e) => onChange({ timeWindowUnit: e.target.value })}
      >
        {TIME_WINDOW_UNITS.map((u) => <option key={u} value={u}>{u}</option>)}
      </select>
    </div>
  );
}

class FilterRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { eventProps: [] };
  }

  componentDidMount() {
    this._loadEventProps(this.props.filter.event);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filter.event !== this.props.filter.event) {
      this._loadEventProps(this.props.filter.event);
    }
  }

  _loadEventProps(eventName) {
    if (!eventName) { this.setState({ eventProps: [] }); return; }
    segmentService.getEventProperties(tableForEvent(eventName), eventName)
      .then((eventProps) => this.setState({ eventProps }))
      .catch(() => this.setState({ eventProps: [] }));
  }

  render() {
    const { filter, onRemove, onUpdate, showConnector, op, onOpChange } = this.props;
    const { eventProps } = this.state;

    const isEvent    = filter.type === 'event';
    const isProperty = ['user-property', 'entity-status', 'earning', 'campaign'].includes(filter.type);

    const did = filter.did !== false;
    const ft  = isEvent
      ? (did ? FILTER_TYPES['event-performed'] : FILTER_TYPES['event-not-performed'])
      : (FILTER_TYPES[filter.type] || {});

    const upd    = (patch) => onUpdate(filter.id, patch);
    const vals   = ft.valsByProp ? ft.valsByProp[filter.prop] : null;
    const propFilters = filter.propFilters || [];
    const updPfs = (pfs) => upd({ propFilters: pfs });
    const propNameListId = 'proplist-' + filter.id;

    return (
      <div className={styles.wrap}>
        {showConnector && (
          <div className={styles.connector}>
            <button className={[styles.opBtn, op === 'AND' ? styles.on : ''].join(' ')} onClick={() => onOpChange('AND')}>AND</button>
            <button className={[styles.opBtn, op === 'OR' ? styles.on : ''].join(' ')} onClick={() => onOpChange('OR')}>OR</button>
          </div>
        )}

        <div
          className={[styles.row, isEvent ? styles.rowEvent : ''].join(' ')}
          style={{ borderLeft: '3px solid ' + ft.tc }}
        >

          {/* ─── Event filter ──────────────────────────────── */}
          {isEvent && (
            <div className={styles.eventBlock}>
            <div className={styles.eventMain}>
              <span className={styles.typeTag} style={{ color: ft.tc, background: ft.col }}>Event</span>

              <div className={styles.didToggle}>
                <button
                  className={[styles.didBtn, did ? styles.didOn : ''].join(' ')}
                  onClick={() => upd({ did: true })}
                >Did</button>
                <button
                  className={[styles.didBtn, !did ? styles.didNotOn : ''].join(' ')}
                  onClick={() => upd({ did: false })}
                >Did Not</button>
              </div>

              <select
                className={styles.sel}
                value={filter.event || ''}
                onChange={(e) => upd({ event: e.target.value, propFilters: [] })}
              >
                <option value="">Select event…</option>
                {APP_EVENTS.map((ev) => <option key={ev} value={ev}>{ev}</option>)}
              </select>

              <span className={styles.dimLbl}>in last</span>

              <TimeWindowInput value={filter.timeWindowValue} unit={filter.timeWindowUnit} onChange={upd} />

              {did && (
                <div className={styles.countGroup}>
                  <select
                    className={styles.selSm}
                    value={filter.countOp || 'at least'}
                    onChange={(e) => upd({ countOp: e.target.value })}
                  >
                    {COUNT_OPS.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <input
                    className={styles.countInp}
                    type="number"
                    min="1"
                    value={filter.countVal || '1'}
                    onChange={(e) => upd({ countVal: e.target.value })}
                  />
                  <span className={styles.dimLbl}>×</span>
                </div>
              )}

              <button className={styles.removeBtn} onClick={() => onRemove(filter.id)}>
                <span className="material-symbols-rounded" style={{ fontSize: 13 }}>close</span>
              </button>
            </div>

              {/* Property sub-filters. Property name/value are free text with an
                  autocomplete of what's actually been seen for this event —
                  any event can carry any property, so nothing here is a fixed
                  schema, just a live suggestion. */}
              {propFilters.length > 0 && (
                <div className={styles.propSection}>
                  <span className={styles.whereBar}>where</span>
                  {propFilters.map((pf, pi) => {
                    const noVal = pf.op === 'is set' || pf.op === 'is not set';
                    const valListId = 'propval-' + pf.id;
                    const sampleValues = eventProps.find((p) => p.name === pf.name)?.sample_values || [];
                    return (
                      <div key={pf.id} className={styles.propRow}>
                        {pi > 0 && <span className={styles.andLbl}>and</span>}
                        <input
                          className={styles.inp}
                          list={propNameListId}
                          placeholder="property name…"
                          value={pf.name}
                          onChange={(e) => updPfs(propFilters.map((p) => (p.id === pf.id ? { ...p, name: e.target.value } : p)))}
                        />
                        <select
                          className={styles.sel}
                          value={pf.op || 'equals'}
                          onChange={(e) => updPfs(propFilters.map((p) => (p.id === pf.id ? { ...p, op: e.target.value } : p)))}
                        >
                          {PROPERTY_OPS.map((o) => <option key={o} value={o}>{o}</option>)}
                        </select>
                        {!noVal && (
                          <>
                            <input
                              className={styles.inp}
                              list={valListId}
                              placeholder="value…"
                              value={pf.val}
                              onChange={(e) => updPfs(propFilters.map((p) => (p.id === pf.id ? { ...p, val: e.target.value } : p)))}
                            />
                            <datalist id={valListId}>
                              {sampleValues.map((v) => <option key={v} value={v} />)}
                            </datalist>
                          </>
                        )}
                        <button
                          className={styles.propRemoveBtn}
                          onClick={() => updPfs(propFilters.filter((p) => p.id !== pf.id))}
                        >
                          <span className="material-symbols-rounded" style={{ fontSize: 12 }}>close</span>
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}

              <datalist id={propNameListId}>
                {eventProps.map((p) => <option key={p.name} value={p.name} />)}
              </datalist>

              {filter.event && (
                <button
                  className={styles.addPropBtn}
                  onClick={() => updPfs([...propFilters, { id: ++_propId, name: '', op: 'equals', val: '' }])}
                >
                  <span className="material-symbols-rounded" style={{ fontSize: 13 }}>add</span>
                  Add property condition
                </button>
              )}
            </div>
          )}

          {/* ─── Profile / entity-status / earning / campaign ── */}
          {isProperty && ft.props && (
            <>
              <span className={styles.typeTag} style={{ color: ft.tc, background: ft.col }}>{ft.label}</span>
              <select
                className={styles.sel}
                value={filter.prop || ''}
                onChange={(e) => upd({ prop: e.target.value, val: '' })}
              >
                <option value="">Select property…</option>
                {ft.props.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
              {ft.ops && (
                <select
                  className={styles.sel}
                  value={filter.op || ft.ops[0]}
                  onChange={(e) => upd({ op: e.target.value })}
                >
                  {ft.ops.map((o) => <option key={o} value={o}>{o}</option>)}
                </select>
              )}
              {!ft.noValue && (
                vals
                  ? (
                    <select
                      className={styles.sel}
                      value={filter.val || ''}
                      onChange={(e) => upd({ val: e.target.value })}
                    >
                      <option value="">Select…</option>
                      {vals.map((v) => <option key={v} value={v}>{v}</option>)}
                    </select>
                  )
                  : (
                    <input
                      className={styles.inp}
                      type={ft.numericValue ? 'number' : 'text'}
                      placeholder="value…"
                      value={filter.val || ''}
                      onChange={(e) => upd({ val: e.target.value })}
                    />
                  )
              )}
              {ft.needsTimeWindow && (
                <>
                  <span className={styles.dimLbl}>in last</span>
                  <TimeWindowInput value={filter.timeWindowValue} unit={filter.timeWindowUnit} onChange={upd} />
                </>
              )}
              <button className={styles.removeBtn} onClick={() => onRemove(filter.id)}>
                <span className="material-symbols-rounded" style={{ fontSize: 13 }}>close</span>
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default FilterRow;
